<template>
  <div>
    <div class="topGo" v-show="!isPad">
      <span class="icon" @click="goHistory"><img class="goHistory" src="../../assets/image/08.png" alt=""></span>
      <span class="iconText">任务追踪</span>
    </div>
    <div class="main">
      <div class="top">
        <a-row class="select">
          <a-col :span="12" class="selectBook" @click.capture="bookSelectShow">
            <span class="lessonName">{{ textSelect.orgDisplayName }}</span>
            <img src="../../assets/image/change.png" alt="" />
          </a-col>
          <a-col :span="12" class="selectClass">
            <a-select v-model='classSelect' style="width: 360px" @change="changeClass">
              <a-select-option :value="item.id" v-for="(item, index) in classData" :key="index">
                {{ item.className }}
              </a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </div>
      <div class="center">
        <div class="title">
          <span class="border"></span>
          <span class="taskDea">任务选择情况</span>
        </div>
        <div class="echarts" id="echartsPie">

        </div>
      </div>
      <div class="bottom">
        <div class="title">
          <span class="border"></span>
          <span class="taskDea">任务提交情况</span>
        </div>
        <div class="echartsBar" id="echartsBar">
        </div>
      </div>
    </div>
    <div class="bookMess">
      <a-modal v-model="lessonShow" footer="" title="" width='840px' @cancel="cancelNewLesson" destroyOnClose>
        <a-select class="selectChoose" v-model="defaultBookName" style="width: 660px" @change="changeBookModel">
          <a-select-option :value="item.id" v-for="item in bookList" :key="item.id">
            {{ item.bookClassify }}
          </a-select-option>
        </a-select>
        <div class="catalog">
          <div class="catalog-content" v-for="(item) in bookLessonList" :key="item.id">
            <div :class="{ title: item.elementName == 1, 'catalog-content-i': true }">
              <span :class="{
                isClickable: item.isClickable && item.isFree,
                disabled: (!item.isClickable && item.parentId !== '0') || !item.isFree
              }" @click="goToLearnPre(item)">
                <span>{{ item.displayName }}</span>
              </span>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import shareState from '../../utils/shareState.js'
import { decryptDes } from 'utils/crypto.js'
export default {
  name: 'TaskHistory',
  data () {
    return {
      isPad: true,
      shareData: shareState.state,
      bookList: [],
      classData: [],
      lessonList: [],
      lessonName: '',
      styleId: '',
      bookId: 1,
      classId: '',
      dataPie: [],
      data: [],
      data1: [],
      userId: '',
      token: '',
      lessonShow: false,
      textSelect: '', //选中的课文
      classSelect: '', //班级选择
      bookLessonList: [],// 课文列表
      defaultBookName: '1', //默认展示的课文名称
      textId: '',
      dataSource: []
    }
  },
  created () {
    this.getAllBookClassify()
  },
  mounted () {
    if (sessionStorage.getItem('textSelect')) {
      this.styleId = JSON.parse(sessionStorage.getItem('textSelect')).id
    } else {
      this.styleId = 2
    }
    this.token = localStorage.getItem('access_token')
    this.classId = this.shareData.homeWorkClassId
    this.init()
    this.getlessonList()
    this.getTask()
  },
  methods: {
    init () {
      //const parameter = decryptDes('5ecfd021795f9a10245329b509849e106cc9d2d77acd05ad4a6c3c1761d3d48e3b226ed0bd4f3a0d8912aeef0ae53a44b7ea35859aff038bdd69909edc94c9029d1c189272ce8bf0')
      if (this.$route.path.indexOf('/accompanyStudy') === 0) {
        this.isPad = false
        this.userId = this.$getUserInfo().id
      } else {
        const parameter = decryptDes(this.$route.params.parameter)
        const params = parameter.split('&')
        this.token = params[0]
        this.userId = params[1]
      }
    },
    getClassNumAndId () {
      return new Promise((resolve, reject) => {
        this.$fetch({
          url: this.$baseUrl + 'ebook/class/common/getMyClassInfo',
          body: {
            token: this.token,
            userId: this.userId
          }
        }).done(res => {
          resolve(res)
        })
      })
    },
    getTask () {
      this.getClassNumAndId().then((res) => {
        console.log(res, 'res')
        if (res && res.resultCode === 0 && res.success) {
          this.classData = res.resultData
          this.classSelect = res.resultData[0].className
          this.classId = res.resultData[0].id
        }
        this.getEcharts()
      })
    },
    changeClass (e) { //切换班级
      this.classId = e
      this.getEcharts()
    },
    changeBook (val) {
      this.bookId = val
      this.getlessonList()
    },
    changeBookModel (e) { //切换书籍
      console.log(e, 'e')
      this.bookId = e
      this.defaultBookName = e
      this.getCatalog()
    },
    changeLesson (val) {
      this.styleId = val
      this.getEcharts()
    },
    goToLearnPre (item) {
      this.textSelect = item
      sessionStorage.setItem('textSelect', JSON.stringify(item))
      localStorage.setItem('styleId', JSON.stringify(item.id))
      this.styleId = item.id
      this.lessonShow = false
      this.getEcharts()
    },
    getEcharts () {
      const param = {
        styleId: this.styleId,
        classId: this.classId,
        teacherId: this.userId
      }
      let _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/task/getTaskFinishStatistics',
        body: param
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.dataPie = res.resultData.map(item => {
            return item.percent
          })
          _this.data = []
          _this.data1 = []
          if (res.resultData != null) {
            res.resultData.forEach(item => {
              _this.data.push(item.finishPercent)
              _this.data1.push({
                value: item.percent,
                name: item.taskName
              })
            })
          }
          let myChart = this.$echarts.init(document.getElementById('echartsPie'))
          let myChart1 = this.$echarts.init(document.getElementById('echartsBar'))
          let option = {
            tooltip: {
              trigger: 'item',
              formatter: '{c}%'
            },
            legend: {
              orient: 'vertical',
              left: 'right',
              bottom: '0'
            },
            series: [
              {
                // name: '访问来源',
                type: 'pie',
                radius: '50%',
                data: _this.data1,
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                },
                itemStyle: {
                  normal: {
                    color: function (params) {
                      let color = ['#8ed3bc', '#f3c450', '#a3af90', '#E1D9C2']
                      return color[params.dataIndex]
                    }
                  }
                },
                label: {
                  normal: {
                    formatter: '{c}%',
                    position: 'inner',
                    show: true
                  }
                }
              }
            ]
          }
          myChart.setOption(option)
          let option1 = {
            tooltip: {
              trigger: 'item',
              formatter: '{b} {c}%'
            },
            legend: {
              data: ['已提交', '未提交'],
              left: 'right',
              top: '0'
            },
            xAxis: {
              type: 'category',
              data: res.resultData.map(item => {
                return item.taskName
              }),
              splitLine: {
                show: false
              },
              // axisTick:{
              //   show: false
              // }
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: '{value} %',
                splitNumber: 5,
              },
              min: 0,
              max: 100,
              splitLine: {
                show: false
              },
              axisTick: {
                show: false
              }
            },
            series: [
              {
                name: '已提交',
                data: res.resultData.map(item => {
                  return item.finishPercent
                }),
                type: 'bar',
                itemStyle: {
                  normal: {
                    color: '@primary-color'
                  }
                }
              },
              {
                name: '未提交',
                data: res.resultData.map(item => {
                  return item.unfinishPercent
                }),
                type: 'bar',
                itemStyle: {
                  normal: {
                    color: '#E1D9C2'
                  }
                }
              }
            ]
          }
          myChart1.setOption(option1)
        } else {
          this.$message.warning(res.resultMessage)
        }
      })
    },
    getAllBookClassify () { //获取书册分类
      let _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/base/getAllBookClassify',
        body: {
          userId: this.userId,
          token: this.token
        }
      }).done(res => {
        if (res && res.success && res.resultCode === 0) {
          _this.bookList = res.resultData
          console.log(_this.bookList, '_this.bookList')
          _this.defaultName = res.resultData[0].bookClassify
        }
      })
      // this.bookList = []
      // this.$store.state.myBookList.forEach(item=>{
      //   if(item.isBuy == 1){
      //     this.bookList.push({
      //       name: item.name,
      //       id: item.id
      //     })
      //   }
      // })
      // this.defaultBookName = this.bookList[0].name || ''
      this.getCatalog()
    },
    getlessonList () { //获取文章
      let _this = this
      // let bookid = localStorage.getItem('syzg-bookId')
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/book/styleList',
        body: {
          bookId: this.bookId,
          userId: this.userId,
          token: this.token
        }
      }).done(res => {
        // console.log(res)
        if (res && res.success && res.resultCode === 0) {
          _this.lessonList = res.resultData
          if (res.resultData.length > 0) {
            _this.lessonName = res.resultData[1].displayName
          } else {
            _this.lessonName = '暂无数据'
          }
        }
      })
    },
    bookSelectShow () {
      this.lessonShow = true
    },
    goHistory () {
      this.$router.go(-1)
    },
    getCatalog () { //获取课文内容
      this.$fetch({
        url: this.$baseUrl + 'ebook/book/styleList',
        body: {
          bookId: this.bookId,
          purchaseVersion: 2,
          token: this.token,
          userId: this.userId
        }
      }).loading(
        () => (this.loading = true),
        () => (this.loading = false)
      ).done(res => {
        this.bookLessonList = res.resultData
        if (sessionStorage.getItem('textSelect')) {
          this.textSelect = JSON.parse(sessionStorage.getItem('textSelect'))
        } else {
          this.textSelect = res.resultData[1]
        }
      })
    },
    cancelNewLesson () {
      this.lessonShow = false
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  width: 1240px;
  height: 800px;
  margin: 0 auto;
  padding: 20px;

  .top {
    height: 80px;
    line-height: 80px;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 12px;

    .colBook {
      text-align: center;
    }

    .colLesson {
      text-align: center;
    }
  }

  .center {
    height: 500px;
    background: #fff;
    margin-top: 20px;
    border-radius: 12px;
  }

  .bottom {
    height: 520px;
    background: #fff;
    margin-top: 20px;
    border-radius: 12px;
  }

  .title {
    height: 40px;
    line-height: 40px;
    padding: 0px 10px;

    .border {
      // display: inline-block;
      // width: 4px;
      // height: 20px;
      // background: orangered;
      // border-radius: 4px;
      // margin-left: 5px;
      // margin-top: 10px;
    }

    .taskDea {
      margin-left: 20px;
      color: #000;
      font-size: 18px;
      margin-top: -5px;
    }
  }

  .echarts {
    width: 800px;
    height: 400px;
    margin: 0 auto;
  }

  .echartsBar {
    width: 800px;
    height: 400px;
    margin: 0 auto;
  }

  /deep/.ant-select-selection {
    background: #f6f6f6;
  }
}

.topGo {
  height: 110px;
  background-color: #fff;
  position: relative;
  padding: 0 50px;

  .goHistory {
    width: 16px;
    height: 32px;
    cursor: pointer;
  }

  .icon {
    position: absolute;
    top: 50%;
    margin-top: -7px;
    left: 50px;
  }

  .iconText {
    position: absolute;
    top: 50%;
    margin-top: -10px;
    left: 100px;
    color: #9d9292;
    font-size: 24px;
  }
}

.select {
  height: 50px;
  background: #fff;

  .selectBook {
    width: 680px;
    height: 44px;
    line-height: 44px;
    text-indent: 20px;
    background: #f8f8f8;
    border-radius: 4px;

    .lessonName {
      font-size: 20px;
      color: #040506;
    }

    img {
      width: 25px;
      height: 25px;
      float: right;
      margin: 10px 15px 0px 0px;
      cursor: pointer;
    }
  }

  .selectClass {
    width: 400px;
    height: 44px;
    line-height: 44px;
    text-indent: 10px;
    background: #f8f8f8;
    margin-left: 30px;
    border-radius: 4px;

    /deep/.ant-select-selection,
    .ant-select .ant-select-enabled {
      background-color: #f8f8f8;
      border: none;
    }

    /deep/.ant-select-selection__placeholder,
    .ant-select-search__field__placeholder {
      color: #040506;
      font-size: 20px;
    }

    /deep/.ant-select-selection-selected-value {
      font-size: 20px;
    }

    /deep/.ant-select-arrow .ant-select-arrow-icon {
      display: block;
      font-size: 20px;
      margin-top: -4px;
      color: #ca9561;
    }
  }
}

.selectChoose {
  margin-left: 50px;
  margin-top: 40px;
}

.catalog {
  // margin-top: 30px;
  width: 800px;
  height: 100%;
  border-radius: @border-radius-base;
  padding-left: 50px;
  // padding-top: 55px;
  padding-right: 50px;
  padding-bottom: 25px;
  position: relative;

  .resource {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 150px;
    z-index: 9;
    cursor: pointer;
  }

  .catalog-content-i {
    font-size: 20px;
    font-family: "PingFangSC-Regular", "Arial Narrow", Arial, sans-serif;
    color: #000000;
    line-height: 220%;
    position: relative;
  }

  .title {
    font-size: 24px;
    font-family: "PingFangSC-Regular", "Arial Narrow", Arial, sans-serif;
    color: #db5647;
    cursor: pointer;
  }

  .isClickable {
    cursor: pointer;

    &:hover {
      color: @primary-color;
    }
  }

  .disabled {
    color: @disabled-color;
  }
}

.recallBox {
  padding: 10px 20px;

  li {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #fff;
    margin: 8px 0px;
    display: flex;
    border-radius: 5px;

    .name {
      flex: 11;
      text-indent: 20px;
      color: #040506;
      font-size: 20px;

      .userImg {
        width: 30px;
        height: 30px;
        margin-top: -5px;
      }

      .userDetail {
        margin-left: 20px;
      }

      .userName {}
    }

    .lookHomeWork {
      flex: 7;
      cursor: pointer;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: @primary-color;
    }

    .argee {
      flex: 3;

      .ant-btn-primary {
        color: #fff;
        background-color: #22C190;
        border-color: #22C190;
      }
    }

    .disArgee {
      flex: 3;

      .ant-btn-danger {
        color: #fff;
        background-color: #DB5647;
        border-color: #DB5647;
      }
    }

    .agreeText {
      color: #22C190;
      margin-right: 20px;
    }

    .disArgeeText {
      color: #DB5647;
      margin-right: 20px;
    }
  }
}

.solveMess {
  height: 600px;
  background: #f6f6f6;
  margin: 24px;

  /deep/.ant-modal-body {
    background-color: #f6f6f6;
  }

  /deep/.ant-modal-content {
    background-color: #f6f6f6;
    padding: 0px;
  }
}

/deep/.ant-table-pagination.ant-pagination {
  float: none;
}

.taskNameColor {
  color: @primary-color;
}
</style>
